import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalDateTime } from '@js-joda/core';
import { LocalTimeRange } from '../../type/shared';
import { RecordingSegment } from './RecordingSegment';
/**
 * Details for a recording. This supersedes RecordingWithSegments except that it only has locationId and departmentId
 * instead of their types, so it has no external dependencies on Core.
 */
export class Recording {
    /**
     * @param id Identifies the recording.
     * @param courtSystemId Identifies the court system the recording belongs to
     * @param locationId Identifies where the recording took place
     * @param departmentId Identifies the department for this recording
     * @param start The local datetime on the client when the recording started
     * @param recordingTypes Types of available source recording media, e.g. TRM, Stream, LocalCapture
     * @param audioChannelCount The number of audio channels
     * @param videoStreamCount The number of video streams
     * @param segments Details of TRM files, streaming sessions etc. which make up the recording
     * @param tags Features or attributes of this recording, eg 'stt', 'multichannel'
     * @param sealedTimes An array of non-overlapping timeframes that have been 'sealed'
     * @param onTheRecordTimes The time ranges during which this recording was on the record
     * @param availableTimes The precise local time ranges that the user can access in this recording
     */
    constructor(id, courtSystemId, locationId, departmentId, start, recordingTypes, audioChannelCount, videoStreamCount, segments, tags, sealedTimes, onTheRecordTimes, availableTimes) {
        this.id = id;
        this.courtSystemId = courtSystemId;
        this.locationId = locationId;
        this.departmentId = departmentId;
        this.recordingTypes = recordingTypes;
        this.audioChannelCount = audioChannelCount;
        this.videoStreamCount = videoStreamCount;
        this.start = start;
        this.segments = segments;
        this.tags = tags;
        this.sealedTimes = sealedTimes;
        this.onTheRecordTimes = onTheRecordTimes;
        this.availableTimes = availableTimes;
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", LocalDateTime)
], Recording.prototype, "start", void 0);
__decorate([
    Type(() => RecordingSegment),
    __metadata("design:type", Array)
], Recording.prototype, "segments", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", Set)
], Recording.prototype, "tags", void 0);
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", Array)
], Recording.prototype, "sealedTimes", void 0);
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", Array)
], Recording.prototype, "onTheRecordTimes", void 0);
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", Array)
], Recording.prototype, "availableTimes", void 0);
export function mapRecordingToPermissionResource(recording) {
    return {
        id: recording.id,
        courtSystemId: recording.courtSystemId,
        locationId: recording.locationId,
        departmentId: recording.departmentId,
    };
}
